import { ICellRendererParams } from "ag-grid-community";
import { Stack, Typography } from "@mui/joy";
import copy from "copy-text-to-clipboard";
import { toast } from "sonner";
import { AgentObj } from "@/types/interfaces/agents";

export const EmailCellRenderer = ({ value, replaceText }: ICellRendererParams<AgentObj> & { replaceText?: string }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!value) return;
    copy(value);
    toast.success(`${value} copied to clipboard`);
  };

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography
        component="a"
        noWrap
        textColor="text.primary"
        href={`mailto:${value || ""}`}
        title="Click to copy"
        onClick={handleClick}
        fontWeight="md"
        sx={{ mr: 1, fontSize: "inherit", "&:hover": { color: "primary.plainColor", textDecoration: "underline" } }}
      >
        {replaceText ? value?.replace(replaceText, "") : value}
      </Typography>
    </Stack>
  );
};
